import React from "react";
import './Body21.css';
import {Link} from "react-router-dom"
import picture330 from './source/picture330.png'
import picture331 from './source/picture331.png'
import picture332 from './source/picture332.png'
import picture333 from './source/picture333.png'





function Body21() {

  return (
    <div className="body21">
      <div className="body21-box1">
        <div className="body21-box2">
          <div className="body21-box3">Staré Město</div>
          <div className="body21-box5"><div className="body21-box4"></div></div>
          <div className="body21-box6">
          <img className="body21-box6-picture" src={picture330} alt="picture1"/>
          <img className="body21-box6-picture" src={picture331} alt="picture1"/>
          <img className="body21-box6-picture" src={picture332} alt="picture1"/>
          <img className="body21-box6-picture" src={picture333} alt="picture1"/>
          </div>
          <div className="body21-box8"><div className="body21-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body21;
